import { render, staticRenderFns } from "./AutoNaming.vue?vue&type=template&id=40fcd540&scoped=true&"
import script from "./AutoNaming.vue?vue&type=script&lang=js&"
export * from "./AutoNaming.vue?vue&type=script&lang=js&"
import style0 from "./AutoNaming.vue?vue&type=style&index=0&id=40fcd540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fcd540",
  null
  
)

export default component.exports